module.exports = __webpack_public_path__ + "static/img/7h.dd4af39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7h.jpg
// module id = bTPS
// module chunks = 0